import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { CanvasFrame, ErrorScreen } from './error-screen';
import { NotFoundScreen } from './not-found-page';

/**
 * Route-level boundary. On a module route it renders inside the shell's panel,
 * so one broken screen never takes the navigation down with it.
 */
export function RouteError({ framed = false }: { framed?: boolean }) {
  const error = useRouteError();
  const navigate = useNavigate();

  const content = isRouteErrorResponse(error) && error.status === 404 ? (
    <NotFoundScreen />
  ) : (
    <ErrorScreen
      title="Esta pantalla no cargó"
      description="El resto de la aplicación sigue en pie: puedes reintentar o irte a otro módulo."
      error={isRouteErrorResponse(error) ? `${error.status} ${error.statusText}` : error}
      onRetry={() => window.location.reload()}
      action={
        <Button variant="secondary" onClick={() => navigate(-1)}>
          Volver
        </Button>
      }
    />
  );

  return framed ? <CanvasFrame>{content}</CanvasFrame> : content;
}
